import { useState } from "react";
import PageWrapper from "../../common/components/PageWrapper";
import CodeGroupBox from "../components/CodeGroupBox";
import CodeBox from "../components/CodeBox";

export type CodeGroup = {
  id: string;
  name: string;
  code: string;
};

export default function CodeContainer() {
  const [group, setGroup] = useState<CodeGroup | null>(null);

  return (
    <PageWrapper isColumnFlex={false}>
      <CodeGroupBox group={group} onGroupSelect={setGroup} />
      <CodeBox group={group} onCancel={() => setGroup(null)} />
    </PageWrapper>
  );
}
